export default {
  h: false,
  e: false,
  c: false,
  cotiCol: false,
  cotiInd: false,
  presta: false
}
